import type { InputHTMLAttributes } from 'react'
import { cls } from './cls'
import { FIELD_BASE } from './field'

/** A single-line text control. Width is left to the caller. */
export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cls(FIELD_BASE, className)} {...rest} />
}
